module.exports = import("https://unpkg.com/@xenova/transformers@2.13.2");;